import { IconButton } from "@/components/ui/icon-button";
import { openBugReport, openSupportEmail } from "@/lib/support-actions";
import { Bug, Home, Mail, SearchX } from "lucide-react";

const notFoundMessage = "We could not find that page. It may have moved, been deleted, or the link may be mistyped.";

export const RootNotFoundComponent = () => {
  return (
    <main className="flex flex-1 items-center justify-center px-4 py-16">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-card p-6 shadow-sm">
        <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <SearchX className="size-6" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-semibold text-card-foreground">Page not found</h1>
        <p className="mt-3 text-sm text-muted-foreground">{notFoundMessage}</p>
        <p className="mt-3 text-sm text-muted-foreground">
          You can head back home, report the broken link, or email support if you need help finding something specific.
        </p>
        <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <IconButton
            className="w-full"
            icon={<Home />}
            onClick={() => {
              window.location.assign("/");
            }}
            type="button"
          >
            Go home
          </IconButton>
          <IconButton
            className="w-full"
            icon={<Bug />}
            onClick={() => {
              void openBugReport({
                body: `I found a missing page in Veronics:\n\n${window.location.href}\n\nI expected to find:`,
                subject: "Veronics missing page report",
              });
            }}
            type="button"
            variant="outline"
          >
            Report bug
          </IconButton>
          <IconButton
            className="w-full sm:col-span-2"
            icon={<Mail />}
            onClick={() => {
              openSupportEmail({
                body: `I need help finding this Veronics page:\n\n${window.location.href}\n\nI was trying to:`,
                subject: "Veronics support request",
              });
            }}
            type="button"
            variant="outline"
          >
            Email support
          </IconButton>
        </div>
      </div>
    </main>
  );
};
